import React from 'react';
import { motion } from 'framer-motion';

const Logo = ({ size = 'md', className = '', theme = 'default' }) => {
  const sizes = {
    sm: { height: 52 },
    md: { height: 82 },
    lg: { height: 100 }
  };

  const currentSize = sizes[size];

  return (
    <div className={`flex items-center ${className}`}>
      <motion.img
        src="/calloclogo.png"
        alt="CALLOC Technologies"
        style={{ height: currentSize.height, width: 'auto' }}
        className="object-contain max-h-none"
        whileHover={{ scale: 1.05 }}
        transition={{ duration: 0.2 }}
      />
    </div>
  );
};

export default Logo;
